import * as React from 'react';
import { FC } from 'react';
import { CONDITION_DESKTOP } from 'shared/common/constants';
import { Button, ImageWithRetina } from 'shared/ui';
import styled from 'styled-components';

type NotCompletedProfileRedBannerProps = {
  title: string;
  description: string;
  buttonText: string;
  action: () => void;
};

export const NotCompletedProfileRedBanner: FC<NotCompletedProfileRedBannerProps> = ({
  title,
  description,
  buttonText,
  action,
}) => (
  <Container className="container">
    <Wrapper>
      <ImageWrapper>
        <ImageWithRetina src="/img/not-comp-info/pic2.png" alt="please" />
      </ImageWrapper>
      <TextWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
      <StyledButton onClick={action}>{buttonText}</StyledButton>
      {/* <IconWrapper onClick={onClose}>
        <SvgCloseNote width="10" height="10" />
      </IconWrapper> */}
    </Wrapper>
  </Container>
);

const Container = styled.div``;
const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 20px;
  padding: 20px;
  background-color: var(--red);
  border-radius: 12px;
  color: var(--white);
  ${CONDITION_DESKTOP} {
    margin-top: 60px;
    padding: 20px 40px;
    flex-direction: row;
  }
`;
const ImageWrapper = styled.div`
  display: none;
  ${CONDITION_DESKTOP} {
    display: block;
    width: 160px;
    height: 110px;
    margin-right: 40px;
    margin-top: -30px;
  }

  img {
    width: 160px;
  }
`;
const TextWrapper = styled.div`
  width: 100%;
`;
const Title = styled.p`
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  margin-bottom: 10px;
  text-align: left;
  ${CONDITION_DESKTOP} {
    text-align: left;
    font-size: 24px;
  }
`;
const Description = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 15px;
  text-align: left;
  ${CONDITION_DESKTOP} {
    font-size: 16px;
    line-height: 20px;
    white-space: pre;
    text-align: left;
  }
`;

const StyledButton = styled(Button)`
  align-self: center;
  width: 212px;
  height: 50px;
  flex-shrink: 0;
  margin-top: 10px;
  background-color: var(--white);
  color: var(--red);
  ${CONDITION_DESKTOP} {
    margin-left: 15px;
    margin-top: 0;
  }
`;
